import { ApiType } from "@gymflow/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { xeroQueryKeys } from "./xeroQueryKeys";

export const useMutationXeroDisableIntegration = ({
  api,
}: {
  api: ApiType;
}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => await api.xeroApi.disableIntegration(),
    onSuccess: async () =>
      await queryClient.invalidateQueries({ queryKey: xeroQueryKeys.all() }),
  });
};
